import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ViewProps } from './document.constants';
import {
  PagesPreviewContainer,
  PagesPreviewPageControls,
  PagesPreviewWrapper,
} from '../shared/pages-preview.style';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';
import ComponentTag from '../shared/component-tag';
import {
  PlayableComponentButtonText,
  PlayableComponentCover,
  PlayableComponentStaticButton,
} from '../shared/playable-component.style';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';
import useGetPDFPreviews from 'approot/shared/pdf-preview/pdf-preview.hooks';

export const DocumentStaticPreview = ({
  type,
  properties,
  stimulusResourceProperties,
}: ViewProps) => {
  const imageUrl = stimulusResourceProperties?.coverImage?.original || '';
  const { data } = useGetPDFPreviews({
    documentKey: stimulusResourceProperties?.documentKey || '',
    previewSize: 800,
  });
  const pagesCount = data?.getPDFPreviews?.length || 0;

  const { imageDimensions, setContainerElement: setImageContainerElement } =
    useImageDimensionEffect({
      imageUrl,
    });

  const coverImage = getClosestImageUrl({
    imageUrls: stimulusResourceProperties?.xlCoverImageUrls || [],
    containerSize: imageDimensions?.width
      ? Math.max(imageDimensions.width, imageDimensions.height)
      : window.innerWidth,
    quality: ImageDisplayQuality.High,
  });

  return (
    <ComponentAspectRatio dimensions={properties.dimensionData}>
      <ComponentAbsoluteWrapper $centred={false}>
        <PagesPreviewContainer ref={setImageContainerElement}>
          <PagesPreviewWrapper>
            <ComponentAbsoluteWrapper>
              <PlayableComponentCover
                $backgroundImg={coverImage || imageUrl}
                $noCover={!coverImage}
                $noPaddingTop
                style={{ width: '100%', height: '100%' }}
              />
            </ComponentAbsoluteWrapper>
          </PagesPreviewWrapper>
        </PagesPreviewContainer>
        {pagesCount && pagesCount > 0 && (
          <PagesPreviewPageControls data-selector="pagination-text">
            <span>{`Page 1 of ${pagesCount}`}</span>
          </PagesPreviewPageControls>
        )}
        <PlayableComponentStaticButton data-selector="btn-start">
          <PlayableComponentButtonText>Start</PlayableComponentButtonText>
        </PlayableComponentStaticButton>
        <ComponentTag
          data-selector="component-tag"
          name={getStimulusLabel(type)}
          iconId={type}
        />
      </ComponentAbsoluteWrapper>
    </ComponentAspectRatio>
  );
};

export default DocumentStaticPreview;
